<div
  style="
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  "
>
  <h1 style="font-weight: 700; font-size: 48px; text-align: center">
    {{ 'error_404' | translate }}<br />{{ 'error_page_not_found' | translate }}
  </h1>
</div>
